import React from 'react';
import PropTypes from 'prop-types';
import Badge from 'components/v2/Badge';
import CustomerSearch from 'components/site/customer-search';
import CustomerSearchV2 from 'components/site/CustomerSearchFilter';
import { unescapeSpecialChars } from 'src/main/js/helpers/helper_functions';

export default function MultiSelectUser({
  type,
  placeholder,
  onSelect,
  onRemove,
  selectedItems,
  multiple,
  useNewSearch,
  searchCustomers,
  userSearchTags,
  className,
}) {
  function handleSelect(item, value) {
    onSelect(item, value);
  }

  function renderSelected() {
    return (
      <div className="my-2 selected">
        {selectedItems.map((c) => {
          const label = c.name || c.company_name;
          return (
            <div key={c._id} className="mb-2">
              <Badge color="green" withRemove onRemove={() => onRemove(c)}>
                {unescapeSpecialChars(label)}
              </Badge>
            </div>
          );
        })}
      </div>
    );
  }

  function getCustomerSearchComponent() {
    if (useNewSearch && searchCustomers) {
      return (
        <CustomerSearchV2
          id="customer-search-input"
          clearOnSelect
          onSelect={handleSelect}
          placeholder={placeholder}
          searchField="name"
          type={type}
          searchCustomers={searchCustomers}
          authorizedOnly={false}
          userTag={userSearchTags}
        />
      );
    }
    return (
      <CustomerSearch
        clearOnSelect
        onSelect={handleSelect}
        placeholder={placeholder}
        type={type}
        dropdownStyle={{ maxHeight: '160px', overflow: 'auto' }}
      />
    );
  }

  return (
    <div className={className}>
      {(multiple || selectedItems.length === 0) && getCustomerSearchComponent()}
      {selectedItems.length ? renderSelected() : null}
    </div>
  );
}

MultiSelectUser.propTypes = {
  type: PropTypes.string,
  placeholder: PropTypes.string,
  onSelect: PropTypes.func,
  onRemove: PropTypes.func,
  selectedItems: PropTypes.array,
  multiple: PropTypes.bool,
  useNewSearch: PropTypes.bool,
  searchCustomers: PropTypes.func,
  userSearchTags: PropTypes.string,
  className: PropTypes.string,
};

MultiSelectUser.defaultProps = {
  onSelect: () => {},
  onRemove: () => {},
  selectedItems: [],
  multiple: true,
  useNewSearch: false,
  userSearchTags: 'Third Party Carrier',
  className: 'mb-4 customer-search',
};
